module.exports = __webpack_public_path__ + "img/mcot_logo_app.0662d8dc.png";